export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.title': 'Login',
  'pages.login.loginTips': 'Please input your username and password',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',

  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.accessControl.pageTitle': 'Access Control',
  'pages.accessControl.menuManagement.createMenu': 'Create Menu',
  'pages.accessControl.menuManagement.editMenu': 'Edit Menu',
  'pages.accessControl.selectedCount': 'Selected {count} items',
  'pages.accessControl.columns.name': 'User Name',
  'pages.accessControl.columns.email': 'Email',
  'pages.accessControl.columns.phone': 'Phone Number',
  'pages.accessControl.columns.access': 'Access Level',
  'pages.accessControl.columns.action': 'Action',
  'pages.accessControl.actions.edit': 'Edit Access',
  'pages.accessControl.editModalTitle': 'Edit User Access',
  'pages.accessControl.editUserName': 'User: {name}',
  'pages.accessControl.newAccess': 'New Access Level',
  'pages.accessControl.access.admin': 'Admin',
  'pages.accessControl.access.user': 'User',
  'pages.accessControl.access.visitor': 'Visitor',
  'pages.accessControl.updateSuccess': 'Access updated successfully',
  'pages.accessControl.updateFailed': 'Failed to update access',
  /** 欢迎页 */
  'pages.welcome.title': 'JETINNO',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.subtitle': 'Real-time Data Monitoring & Analytics Platform',
  'pages.welcome.stat.onlineDevices': 'Online Devices',
  'pages.welcome.stat.totalDevices': 'Total Devices',
  'pages.welcome.stat.registeredUsers': 'Registered Users',
  'pages.welcome.stat.onlineUsers': 'Online Users',
  'pages.welcome.chart.weeklyCups': 'Weekly Cups Made',
  'pages.welcome.chart.todayRatio': "Today's Coffee Type Ratio",
  'pages.welcome.chart.noData': 'No Data',
  'pages.welcome.chart.materialTotal': 'Total Material Consumption',
  'pages.welcome.chart.globalMap': 'Global Coffee Machine Map',
  'pages.welcome.chart.salesCups': 'Cups Sold',
  'pages.welcome.chart.cupsUnit': '{cups} cups',
  'pages.welcome.chart.total': 'Total',
  'pages.welcome.material.rawLoss': 'Raw Material Consumption',
  'pages.welcome.material.consumableLoss': 'Consumables Consumption',
  'pages.welcome.material.maintainLoss': 'Maintenance Supplies Consumption',
  'pages.welcome.material.coffeeBeans': 'Coffee Beans',
  'pages.welcome.material.water': 'Water',
  'pages.welcome.material.milk': 'Milk',
  'pages.welcome.material.chocolate': 'Chocolate Sauce',
  'pages.welcome.material.filterPaper': 'Filter Paper',
  'pages.welcome.material.cleaningTablets': 'Cleaning Tablets',
  'pages.welcome.material.lubricant': 'Lubricant',
  'pages.welcome.material.descaling': 'Descaling Agent',
  'pages.welcome.material.unitG': 'g',
  'pages.welcome.material.unitMl': 'ml',
  'pages.welcome.material.unitPcs': 'pcs',
  'pages.welcome.material.unitTablets': 'pcs',
  'pages.welcome.material.category.raw': 'Raw Material',
  'pages.welcome.material.category.consumable': 'Consumables',
  'pages.welcome.material.category.maintain': 'Maintenance',
  'pages.welcome.day.sun': 'Sun',
  'pages.welcome.day.mon': 'Mon',
  'pages.welcome.day.tue': 'Tue',
  'pages.welcome.day.wed': 'Wed',
  'pages.welcome.day.thu': 'Thu',
  'pages.welcome.day.fri': 'Fri',
  'pages.welcome.day.sat': 'Sat',
  'pages.welcome.refresh': 'Refresh Data',
  'pages.welcome.globe.loading': 'Loading 3D Globe...',
  'pages.welcome.globe.error': 'Failed to load globe model',
  'pages.welcome.globe.retry': 'Retry',
  'pages.welcome.globe.deviceCount': 'Device Count',
  /**角色管理页 */
  'pages.accessControl.roleManagement.roleId': 'Role ID',
  'pages.accessControl.roleManagement.roleName': 'Role Name',
  'pages.accessControl.roleManagement.status': 'Status',
  'pages.accessControl.roleManagement.roleDescription': 'Role Description',
  'pages.accessControl.roleManagement.permissionCount': 'Permission Count',
  'pages.accessControl.roleManagement.createTime': 'Create Time',
  'pages.accessControl.operation': 'Operation',
  'pages.accessControl.roleManagement.editRole': 'Edit Role',
  'pages.accessControl.roleManagement.enableRole': 'Enable',
  'pages.accessControl.roleManagement.disableRole': 'Disable',
  'pages.accessControl.roleManagement.addRole': 'Add Role',
  'pages.accessControl.roleManagement.editRole': 'Edit Role',
  'pages.accessControl.roleManagement.basicInfo': 'Basic Info',
  'pages.accessControl.roleManagement.permissionConfig': 'Permission Config',
  'pages.accessControl.roleManagement.roleMark': 'Role Mark',
  'pages.accessControl.roleManagement.placeholderName': 'Enter role name',
  'pages.accessControl.roleManagement.ruleName': 'Please enter role name',
  'pages.accessControl.roleManagement.ruleNameMax': 'Role name cannot exceed 20 characters',
  'pages.accessControl.roleManagement.placeholderMark': 'Enter role mark',
  'pages.accessControl.roleManagement.ruleMark': 'Please enter role mark',
  'pages.accessControl.roleManagement.ruleMarkMax': 'Role mark cannot exceed 50 characters',
  'pages.accessControl.roleManagement.rulePermission': 'Please select at least one permission',
  'pages.accessControl.roleManagement.loading': 'Loading...',
  'pages.accessControl.roleManagement.loadPermissionFailed': 'Failed to load permission data',
  'pages.accessControl.roleManagement.deleteConfirm': 'Are you sure to delete this role? This action cannot be undone.',
  'pages.accessControl.roleManagement.deleteSuccess': 'Role deleted successfully',
  'pages.accessControl.roleManagement.deleteFailed': 'Failed to delete role',
  'pages.accessControl.roleManagement.editSuccess': 'Role updated successfully',
  'pages.accessControl.roleManagement.editFailed': 'Failed to update role',
  'pages.accessControl.roleManagement.createSuccess': 'Role created successfully',
  'pages.accessControl.roleManagement.createFailed': 'Failed to create role',
  'pages.accessControl.roleManagement.loadFailed': 'Failed to load role list',
  'pages.accessControl.userManagement.addUser': 'Add User',
  'pages.accessControl.userManagement.deleteConfirm': 'Are you sure to delete this user? This action cannot be undone.',
  'pages.accessControl.userManagement.deleteSuccess': 'User deleted successfully',
  'pages.accessControl.userManagement.deleteFailed': 'Failed to delete user',
  'pages.accessControl.userManagement.editSuccess': 'User updated successfully',
  'pages.accessControl.userManagement.editFailed': 'Failed to update user',
  'pages.accessControl.userManagement.createSuccess': 'User created successfully',
  'pages.accessControl.userManagement.createFailed': 'Failed to create user',
  'pages.accessControl.userManagement.loadFailed': 'Failed to load user list',
  'pages.accessControl.userManagement.statusChanged': '{userName} {status}',
  'pages.accessControl.userManagement.statusFailed': 'Failed to update user status',
  'pages.accessControl.userManagement.basicInfo': 'Basic Info',
  'pages.accessControl.userManagement.editUser': 'Edit User',
  'pages.accessControl.userManagement.password': 'Password',
  'pages.accessControl.userManagement.confirmPassword': 'Confirm Password',
  'pages.accessControl.userManagement.role': 'Role',
  'pages.accessControl.userManagement.placeholderEmail': 'Enter email',
  'pages.accessControl.userManagement.ruleEmail': 'Please enter email',
  'pages.accessControl.userManagement.ruleEmailValid': 'Please enter a valid email address',
  'pages.accessControl.userManagement.placeholderPassword': 'Enter password',
  'pages.accessControl.userManagement.rulePassword': 'Please enter password',
  'pages.accessControl.userManagement.rulePasswordMin': 'Password must be at least 6 characters',
  'pages.accessControl.userManagement.rulePasswordMax': 'Password cannot exceed 20 characters',
  'pages.accessControl.userManagement.placeholderConfirm': 'Confirm password',
  'pages.accessControl.userManagement.ruleConfirm': 'Please confirm password',
  'pages.accessControl.userManagement.rulePasswordMismatch': 'Passwords do not match',
  'pages.accessControl.userManagement.placeholderNick': 'Enter nickname',
  'pages.accessControl.userManagement.ruleNick': 'Please enter nickname',
  'pages.accessControl.userManagement.ruleNickMax': 'Nickname cannot exceed 50 characters',
  'pages.accessControl.userManagement.placeholderRole': 'Select role(s)',
  'pages.accessControl.userManagement.ruleRole': 'Please select at least one role',
  /**用户管理页 */
  'pages.accessControl.userManagement.id': 'id',
  'pages.accessControl.userManagement.user_name': 'Username',
  'pages.accessControl.userManagement.email': 'Email',
  'pages.accessControl.userManagement.nickName': 'Nickname',
  'pages.accessControl.userManagement.status': 'Status',
  'pages.accessControl.userManagement.addUser': 'Add User',
  // 设备管理 - 设备列表
  'pages.deviceControl.deviceManagement.deviceId': 'SN',
  'pages.deviceControl.deviceManagement.vmc_no': 'vmc_no',
  'pages.deviceControl.deviceManagement.deviceName': 'deviceName',
  'pages.deviceControl.deviceManagement.region-device': 'region-device',
  'pages.deviceControl.deviceManagement.device_model': 'device_model',
  'pages.deviceControl.deviceManagement.use_status': 'use_status',
  'pages.deviceControl.deviceManagement.iot_status': 'iot_status',
  'pages.deviceControl.deviceManagement.device_config_id': 'device_config',
  'pages.deviceControl.deviceManagement.ipAddress': 'ipAddress',
  'pages.deviceControl.deviceManagement.createTime': 'createTime',
  'pages.deviceControl.deviceManagement.lastOnlineTime': 'lastOnlineTime',
  // 设备管理 - 设备系列
  'pages.deviceControl.seriesDevice.deviceSeriesID': 'Series ID',
  'pages.deviceControl.seriesDevice.deviceSeriesName': 'Series Name',
  'pages.deviceControl.seriesDevice.deviceSeriesDescription': 'Series Description',
  'pages.deviceControl.seriesDevice.manufacturer': 'Manufacturer',
  'pages.deviceControl.seriesDevice.createTime': 'Create Time',
  'pages.deviceControl.seriesDevice.updateTime': 'Update Time',
  'pages.deviceControl.seriesDevice.operation': 'Operation',
  'pages.deviceControl.seriesDevice.editSeries': 'Edit Series',
  'pages.deviceControl.seriesDevice.addSeries': 'Add Series',
  // 设备管理 - 设备型号
  'pages.deviceControl.modelDevice.deviceModelID': 'deviceModelID',
  'pages.deviceControl.modelDevice.deviceModelName': 'deviceModelName',
  'pages.deviceControl.modelDevice.deviceCategory': 'Device Category',
  'pages.deviceControl.modelDevice.promotionName': 'Promotion Name',
  'pages.deviceControl.modelDevice.deviceType': 'Device Type',
  'pages.deviceControl.modelDevice.serial': 'Serial',
  'pages.deviceControl.modelDevice.android': 'Android',
  // 设备管理 - 设备分类
  'pages.deviceControl.categoryDevice.deviceCategoryID': 'deviceCategoryID',
  'pages.deviceControl.categoryDevice.deviceCategoryName': 'deviceCategoryName',
  // 设备管理 - 配置组设备
  'pages.deviceControl.configGroupDevice.configGroupID': 'configGroupID',
  'pages.deviceControl.configGroupDevice.configGroupName': 'configGroupName',
  'pages.deviceControl.configGroupDevice.createUser': 'createUser',
  'pages.deviceControl.configGroupDevice.createTime': 'createTime',
  'pages.deviceControl.configGroupDevice.updateTime': 'updateTime',
  // 设备管理 - 配置设备
  'pages.deviceControl.configDevice.editConfig': 'Edit Config',
  'pages.deviceControl.configDevice.addConfig': 'Add Config',
  'pages.deviceControl.configDevice.configName': 'Config Name',
  'pages.deviceControl.configDevice.configNamePlaceholder': 'Enter config name',
  'pages.deviceControl.configDevice.configNameRequired': 'Please enter config name',
  'pages.deviceControl.configDevice.configNameMaxLength': 'Config name cannot exceed 50 characters',
  'pages.deviceControl.configDevice.specs': 'Specs',
  'pages.deviceControl.configDevice.specsPlaceholder': 'Enter specs',
  'pages.deviceControl.configDevice.specsRequired': 'Please enter specs',
  'pages.deviceControl.configDevice.statusPlaceholder': 'Select status',
  'pages.deviceControl.configDevice.statusRequired': 'Please select status',
  'pages.deviceControl.configDevice.configGroup': 'Config Group',
  'pages.deviceControl.configDevice.configGroupPlaceholder': 'Select config group',
  'pages.deviceControl.configDevice.configGroupRequired': 'Please select config group',
  'pages.deviceControl.configDevice.notSelected': 'Not Selected',
  'pages.deviceControl.configDevice.deviceModel': 'Device Model (Multiple)',
  'pages.deviceControl.configDevice.deviceModelPlaceholder': 'Select device model',
  'pages.deviceControl.configDevice.fetchModelFailed': 'Failed to get device model list',
  'pages.deviceControl.configDevice.fetchGroupFailed': 'Failed to get config group list',
  'pages.deviceControl.configDevice.configDeviceID': 'ID',
  'pages.deviceControl.configDevice.configName': 'configName',
  'pages.deviceControl.configDevice.specs': 'specs',
  'pages.deviceControl.configDevice.device_config_group_name': 'configGroup',
  'pages.deviceControl.configDevice.configIDGroup': 'configIDGroup',
  'pages.deviceControl.configDevice.device_model_name': 'deviceModelName',
  'pages.deviceControl.configDevice.configType': 'configType',
  'pages.deviceControl.configDevice.createTime': 'createTime',
  'pages.deviceControl.configDevice.updateTime': 'updateTime',
  // 设备管理 - 饮品配方
  'pages.deviceControl.drinkManagement.drinkID': 'drinkID',
  'pages.deviceControl.drinkManagement.drinkName': 'drinkName',
  'pages.deviceControl.drinkManagement.drinkType': 'drinkType',
  'pages.deviceControl.drinkManagement.createTime': 'createTime',
  'pages.deviceControl.drinkManagement.updateTime': 'updateTime',
  'pages.deviceControl.drinkManagement.drinkPrice': 'drinkPrice',
  'pages.deviceControl.drinkManagement.description': 'description',
  'pages.deviceControl.drinkManagement.status': 'status',
  'pages.deviceControl.drinkManagement.price': 'price',
  'pages.deviceControl.drinkManagement.ingredients': 'Ingredients',
  'pages.deviceControl.drinkManagement.beverageCount': 'Beverages',
  'pages.deviceControl.drinkManagement.configName': 'Config Name',
  'pages.deviceControl.drinkManagement.drinkDetail': 'Drink Detail',
  'pages.deviceControl.drinkManagement.beverageInfo': 'Beverage Recipe',
  // 设备管理 - 饮品信息
  'pages.deviceControl.beverageInformation.beverageId': 'Beverage ID',
  'pages.deviceControl.beverageInformation.nameCn': 'Name (CN)',
  'pages.deviceControl.beverageInformation.nameEn': 'Name (EN)',
  'pages.deviceControl.beverageInformation.status': 'Status',
  'pages.deviceControl.beverageInformation.createTime': 'Create Time',
  'pages.deviceControl.beverageInformation.updateTime': 'Update Time',
  // 设备管理 - 设备升级包
  'pages.deviceControl.deviceUpgrade.deviceUpgradeID': 'deviceUpgradeID',
  'pages.deviceControl.deviceUpgrade.deviceModel': 'deviceModel',
  'pages.deviceControl.deviceUpgrade.upgradeType': 'upgradeType',
  'pages.deviceControl.deviceUpgrade.createTime': 'createTime',
  'pages.deviceControl.deviceUpgrade.updateTime': 'updateTime',
  'pages.deviceControl.deviceUpgrade.deviceType': 'deviceType',
  'pages.deviceControl.deviceUpgrade.fileSize': 'fileSize',
  'pages.deviceControl.deviceUpgrade.status': 'status',
  'pages.deviceControl.deviceUpgrade.version': 'version',
  'pages.deviceControl.deviceUpgrade.packageType': 'packageType',
  // 设备管理 - 设备说明书
  'pages.deviceControl.deviceManual.deviceManualID': 'deviceManualID',
  'pages.deviceControl.deviceManual.deviceModel': 'deviceModel',
  'pages.deviceControl.deviceManual.fileSize': 'fileSize',
  'pages.deviceControl.deviceManual.description': 'description',
  'pages.deviceControl.deviceManual.status': 'status',
  'pages.deviceControl.deviceManual.createTime': 'createTime',
  'pages.deviceControl.deviceManual.updateTime': 'updateTime',
  'pages.deviceControl.deviceManual.documentTitle': 'documentTitle',
  'pages.deviceControl.deviceManual.deviceType': 'deviceType',
  'pages.deviceControl.deviceManual.version': 'version',
  // 应用管理 - 应用升级包
  'pages.applicationManagement.applicationUpgradePackage.id': 'ID',
  'pages.applicationManagement.applicationUpgradePackage.appName': 'Application Name',
  'pages.applicationManagement.applicationUpgradePackage.version': 'Version',
  'pages.applicationManagement.applicationUpgradePackage.platform': 'Platform',
  'pages.applicationManagement.applicationUpgradePackage.size': 'Size',
  'pages.applicationManagement.applicationUpgradePackage.status': 'Status',
  'pages.applicationManagement.applicationUpgradePackage.releaseTime': 'Release Time',
  // 应用管理 - 应用账户
  'pages.applicationManagement.applicationAccount.id': 'ID',
  'pages.applicationManagement.applicationAccount.appName': 'Application Name',
  'pages.applicationManagement.applicationAccount.appId': 'Application ID',
  'pages.applicationManagement.applicationAccount.appKey': 'Application Key',
  'pages.applicationManagement.applicationAccount.status': 'Status',
  'pages.applicationManagement.applicationAccount.createTime': 'Create Time',
  'pages.applicationManagement.applicationAccount.updateTime': 'Update Time',
  // 应该管理 - 应用用户设备
  'pages.applicationManagement.applicationUserDevice.id': 'ID',
  'pages.applicationManagement.applicationUserDevice.userName': 'User Name',
  'pages.applicationManagement.applicationUserDevice.appName': 'Application Name',
  'pages.applicationManagement.applicationUserDevice.deviceName': 'Device Name',
  'pages.applicationManagement.applicationUserDevice.deviceType': 'Device Type',
  'pages.applicationManagement.applicationUserDevice.bindTime': 'Bind Time',
  'pages.applicationManagement.applicationUserDevice.lastActiveTime': 'Last Active Time',
  'pages.applicationManagement.applicationUserDevice.status': 'Status',
  // 应用管理 - 应用协议
  'pages.applicationManagement.applicationAgreement.id': 'ID',
  'pages.applicationManagement.applicationAgreement.appName': 'Application Name',
  'pages.applicationManagement.applicationAgreement.version': 'Version',
  'pages.applicationManagement.applicationAgreement.content': 'Content',
  'pages.applicationManagement.applicationAgreement.status': 'Status',
  'pages.applicationManagement.applicationAgreement.createTime': 'Create Time',
  'pages.applicationManagement.applicationAgreement.updateTime': 'Update Time',
  'pages.applicationManagement.applicationAgreement.type': 'Type',
  'pages.applicationManagement.applicationAgreement.title': 'Title',
  'pages.applicationManagement.applicationAgreement.publishTime': 'Publish Time',
  /** Common Operations */
  'pages.common.id': 'ID',
  /** Common Operations */
  'pages.common.operation': 'Operation',
  'pages.common.view': 'View',
  'pages.common.edit': 'Edit',
  'pages.common.delete': 'Delete',
  'pages.common.add': 'Add',
  'pages.common.save': 'Save',
  'pages.common.cancel': 'Cancel',
  'pages.common.confirm': 'Confirm',
  'pages.common.close': 'Close',
  'pages.common.search': 'Search',
  'pages.common.reset': 'Reset',
  'pages.common.refresh': 'Refresh',
  'pages.common.download': 'Download',
  'pages.common.retry': 'Retry',
  'pages.common.publish': 'Publish',
  'pages.common.unbind': 'Unbind',
  'pages.common.upload': 'Upload',
  'pages.common.batchDelete': 'Batch Delete',
  'pages.common.selectedCount': '{count} selected',
  'pages.common.totalCount': 'Total {total} items',
  'pages.common.totalRecords': 'Total {total} records',
  /** Common Status */
  'pages.common.status.enable': 'Enable',
  'pages.common.status.disable': 'Disable',
  'pages.common.status.yes': 'Yes',
  'pages.common.status.no': 'No',
  'pages.common.status.unknown': 'Unknown',
  'pages.common.status.online': 'Online',
  'pages.common.status.offline': 'Offline',
  'pages.common.status.success': 'Success',
  'pages.common.status.failed': 'Failed',
  'pages.common.status.all': 'All',
  'pages.common.status.listed': 'Listed',
  'pages.common.status.delisted': 'Delisted',
  'pages.common.status.pending': 'Pending',
  /** Common Confirm Dialog */
  'pages.common.confirmDelete': 'Confirm Delete',
  'pages.common.confirmPublish': 'Confirm Publish',
  'pages.common.confirmDeactivate': 'Confirm Deactivate',
  'pages.common.confirmUnbind': 'Confirm Unbind',
  /** Common Messages */
  'pages.common.uploadSuccess': 'Upload successful',
  'pages.common.uploadFailed': 'Upload failed',
  'pages.common.createSuccess': 'Created successfully',
  'pages.common.createFailed': 'Creation failed',
  'pages.common.updateSuccess': 'Updated successfully',
  'pages.common.updateFailed': 'Update failed',
  'pages.common.deleteSuccess': 'Deleted successfully',
  'pages.common.deleteFailed': 'Delete failed',
  'pages.common.operateFailed': 'Operation failed',
  'pages.common.loadFailed': 'Failed to load data',
  'pages.common.publishConfirm': 'Confirm Publish',
  'pages.common.publishSuccess': 'Publish successful',
  'pages.common.publishFailed': 'Publish failed',
  /** Application Account */
  'pages.applicationManagement.applicationAccount.userName': 'Username',
  'pages.applicationManagement.applicationAccount.nickName': 'Nickname',
  'pages.applicationManagement.applicationAccount.email': 'Email',
  'pages.applicationManagement.applicationAccount.phone': 'Phone',
  'pages.applicationManagement.applicationAccount.openId': 'Open ID',
  'pages.applicationManagement.applicationAccount.role': 'Role',
  'pages.applicationManagement.applicationAccount.uniqueId': 'Unique ID',
  'pages.applicationManagement.applicationAccount.userName.placeholder': 'Please enter username',
  'pages.applicationManagement.applicationAccount.nickName.placeholder': 'Please enter nickname',
  'pages.applicationManagement.applicationAccount.email.placeholder': 'Please enter email',
  'pages.applicationManagement.applicationAccount.email.invalid': 'Please enter a valid email address',
  'pages.applicationManagement.applicationAccount.phone.placeholder': 'Please enter phone number',
  'pages.applicationManagement.applicationAccount.status.placeholder': 'Please select status',
  'pages.applicationManagement.applicationAccount.openId.placeholder': 'Please enter Open ID',
  'pages.applicationManagement.applicationAccount.role.placeholder': 'Please select role',
  'pages.applicationManagement.applicationAccount.uniqueId.placeholder': 'Please enter Unique ID',
  'pages.applicationManagement.applicationAccount.createTime': 'Create Time',
  'pages.applicationManagement.applicationAccount.updateTime': 'Update Time',
  'pages.applicationManagement.applicationAccount.addTitle': 'Add Account',
  'pages.applicationManagement.applicationAccount.editTitle': 'Edit Account',
  'pages.applicationManagement.applicationAccount.viewTitle': 'View Account',
  'pages.applicationManagement.applicationAccount.addAccount': 'Add Account',
  'pages.applicationManagement.applicationAccount.role.productionManage': 'Production Admin',
  'pages.applicationManagement.applicationAccount.role.production': 'Production',
  'pages.applicationManagement.applicationAccount.role.ordinaryUser': 'Ordinary User',
  /** Application Agreement */
  'pages.applicationManagement.applicationAgreement.language': 'Language',
  'pages.applicationManagement.applicationAgreement.fileName': 'File Name',
  'pages.applicationManagement.applicationAgreement.language.cn': 'Chinese',
  'pages.applicationManagement.applicationAgreement.language.en': 'English',
  'pages.applicationManagement.applicationAgreement.type.privacy': 'Privacy Policy',
  'pages.applicationManagement.applicationAgreement.type.service': 'Terms of Service',
  'pages.applicationManagement.applicationAgreement.addTitle': 'Add Agreement',
  'pages.applicationManagement.applicationAgreement.editTitle': 'Edit Agreement',
  'pages.applicationManagement.applicationAgreement.deleteConfirm': 'Are you sure to delete agreement "{name}"? This action cannot be undone.',
  'pages.applicationManagement.applicationAgreement.placeholder.name': 'Enter agreement name',
  'pages.applicationManagement.applicationAgreement.placeholder.language': 'Select language',
  'pages.applicationManagement.applicationAgreement.placeholder.type': 'Select agreement type',
  /** Application User Device */
  'pages.applicationManagement.applicationUserDevice.userId': 'User ID',
  'pages.applicationManagement.applicationUserDevice.nickname': 'Nickname',
  'pages.applicationManagement.applicationUserDevice.deviceId': 'Device ID',
  'pages.applicationManagement.applicationUserDevice.deviceModel': 'Device Model',
  'pages.applicationManagement.applicationUserDevice.deviceName': 'Device Name',
  'pages.applicationManagement.applicationUserDevice.macAddress': 'MAC Address',
  /** Device Manual */
  'pages.deviceControl.deviceManual.uploadManual': 'Upload Manual',
  /** Device Upgrade Package */
  'pages.deviceControl.deviceUpgrade.uploadPackage': 'Upload Package',
  'pages.deviceControl.deviceUpgrade.deviceName': 'Device Name',
  'pages.deviceControl.deviceUpgrade.deviceStatus': 'Device Status',
  'pages.deviceControl.deviceUpgrade.packageType': 'Package Type',
  'pages.deviceControl.deviceUpgrade.forceUpgrade': 'Forced Upgrade',
  'pages.deviceControl.deviceUpgrade.nonForceUpgrade': 'Non-Forced Upgrade',
  /** Device Config Group */
  'pages.deviceControl.configGroup.configGroupID': 'Config Group ID',
  'pages.deviceControl.configGroup.configGroupName': 'Config Group Name',
  'pages.deviceControl.configGroup.seriesName': 'Device Series',
  'pages.deviceControl.configGroup.addConfigGroup': 'Add Config Group',
  'pages.deviceControl.configGroup.editTitle': 'Edit Config Group',
  'pages.deviceControl.configGroup.addTitle': 'Add Config Group',
  'pages.deviceControl.configGroup.name': 'Config Group Name',
  'pages.deviceControl.configGroup.placeholderName': 'Enter config group name',
  'pages.deviceControl.configGroup.ruleName': 'Please enter config group name',
  'pages.deviceControl.configGroup.ruleNameMax': 'Config group name cannot exceed 50 characters',
  'pages.deviceControl.configGroup.placeholderSeries': 'Select device series',
  'pages.deviceControl.configGroup.ruleSeries': 'Please select device series',
  'pages.deviceControl.configGroup.fetchSeriesFailed': 'Failed to load device series list',
  'pages.deviceControl.configGroup.deleteConfirm': 'Are you sure to delete config group "{name}"? This action cannot be undone.',
  /** Device Config */
  'pages.deviceControl.config.configDeviceID': 'Config ID',
  'pages.deviceControl.config.configName': 'Config Name',
  'pages.deviceControl.config.specs': 'Specs',
  'pages.deviceControl.config.configGroupName': 'Config Group Name',
  'pages.deviceControl.config.deviceModelName': 'Device Model Name',
  'pages.deviceControl.config.status': 'Status',
  'pages.deviceControl.config.addConfig': 'Add Config',
  'pages.deviceControl.config.deleteConfirm': 'Are you sure to delete config "{name}"? This action cannot be undone.',
  /** Device Category */
  'pages.deviceControl.category.categoryId': 'Category ID',
  'pages.deviceControl.category.series': 'Device Series',
  'pages.deviceControl.category.addCategory': 'Add Category',
  'pages.deviceControl.category.editTitle': 'Edit Category',
  'pages.deviceControl.category.addTitle': 'Add Category',
  'pages.deviceControl.category.categoryName': 'Category Name',
  'pages.deviceControl.category.placeholderName': 'Enter category name',
  'pages.deviceControl.category.ruleName': 'Please enter category name',
  'pages.deviceControl.category.ruleMaxLength': 'Category name cannot exceed 50 characters',
  'pages.deviceControl.category.seriesSelect': 'Device Series',
  'pages.deviceControl.category.placeholderSeries': 'Select device series',
  'pages.deviceControl.category.ruleSeries': 'Please select device series',
  /** Device Category - Messages */
  'pages.deviceControl.category.deleteConfirm': 'Are you sure to delete this device category? This action cannot be undone.',
  'pages.deviceControl.category.fetchSeriesFailed': 'Failed to get device series list',
  'pages.deviceControl.category.fetchListFailed': 'Failed to get device category list',
  /** Device Series */
  'pages.deviceControl.series.addSeries': 'Add Series',
  'pages.deviceControl.series.deviceSeriesID': 'Series ID',
  'pages.deviceControl.series.deviceSeriesName': 'Series Name',
  'pages.deviceControl.series.deleteConfirm': 'Are you sure to delete series "{name}"? This action cannot be undone.',
  'pages.deviceControl.series.deleteSuccess': 'Series deleted successfully',
  'pages.deviceControl.series.deleteFailed': 'Failed to delete series',
  'pages.deviceControl.series.placeholderName': 'Enter series name',
  'pages.deviceControl.series.ruleName': 'Please enter series name',
  'pages.deviceControl.series.ruleNameMax': 'Series name cannot exceed 50 characters',
  /** Device Model */
  'pages.deviceControl.model.serial': 'Serial',
  'pages.deviceControl.model.android': 'Android',
  'pages.deviceControl.model.addModel': 'Add Model',
  'pages.deviceControl.model.editTitle': 'Edit Model',
  'pages.deviceControl.model.addTitle': 'Add Model',
  'pages.deviceControl.model.editDevice': 'Edit Device Info',
  'pages.deviceControl.model.deviceId': 'Device ID',
  'pages.deviceControl.model.deviceModel': 'Device Model',
  'pages.deviceControl.model.deviceCategory': 'Device Category',
  'pages.deviceControl.model.extModel': 'External Model (Marketing Name)',
  'pages.deviceControl.model.type': 'Type',
  'pages.deviceControl.model.selectCategory': 'Select category',
  'pages.deviceControl.model.selectType': 'Select type',
  'pages.deviceControl.model.selectModel': 'Select model',
  'pages.deviceControl.model.selectStatus': 'Select status',
  'pages.deviceControl.model.ruleDeviceId': 'Please enter device ID',
  'pages.deviceControl.model.placeholderDeviceId': 'Please enter device ID',
  'pages.deviceControl.model.ruleModel': 'Please enter device model',
  'pages.deviceControl.model.placeholderModel': 'Enter device model name',
  'pages.deviceControl.model.ruleName': 'Please enter device model name',
  'pages.deviceControl.model.placeholderName': 'Enter device model name',
  'pages.deviceControl.model.ruleCategory': 'Please select device category',
  'pages.deviceControl.model.ruleExtModel': 'Please enter external model',
  'pages.deviceControl.model.placeholderExtModel': 'Enter external model (marketing name)',
  /** Device Model - Messages */
  'pages.deviceControl.model.fetchModelListFailed': 'Failed to get device model list',
  'pages.deviceControl.model.fetchCategoryListFailed': 'Failed to get device category list',
  'pages.deviceControl.model.deleteConfirm': 'Are you sure to delete device model "{name}"? This action cannot be undone.',
  'pages.deviceControl.model.deleteSuccess': 'Device model deleted successfully',
  'pages.deviceControl.model.deleteFailed': 'Failed to delete device model',
  'pages.deviceControl.model.addSuccess': 'Device model added successfully',
  'pages.deviceControl.model.addFailed': 'Failed to add device model',
  'pages.deviceControl.model.formValidateFailed': 'Form validation failed',
  'pages.deviceControl.model.updateSuccess': 'Device model updated successfully',
  'pages.deviceControl.model.updateFailed': 'Failed to update device model',
  /** Device List */
  'pages.deviceControl.list.macId': 'MAC ID',
  'pages.deviceControl.list.deviceConfig': 'Device Config',
  'pages.deviceControl.list.editDevice': 'Edit Device',
  'pages.deviceControl.list.editDeviceInfo': 'Edit Device Information',
  'pages.deviceControl.list.snCode': 'SN Code',
  'pages.deviceControl.list.deviceNumber': 'Device Number',
  'pages.deviceControl.list.enableDisable': 'Enable/Disable',
  'pages.deviceControl.list.transferTitle': 'Device Number Transfer',
  'pages.deviceControl.list.transferFrom': 'Current MAC ID',
  'pages.deviceControl.list.transferTo': 'Transfer to MAC ID',
  'pages.deviceControl.list.transferPlaceholder': 'Enter target MAC ID',
  'pages.deviceControl.list.notSelected': 'Not Selected',
  'pages.deviceControl.list.toolTransfer': 'Device Transfer',
  'pages.deviceControl.list.unbindConfirm': 'Are you sure to unbind device {id}? Re-binding required afterwards.',
  'pages.deviceControl.list.deactivateConfirm': 'Are you sure to deactivate device {id}? It cannot be recovered.',
  'pages.deviceControl.list.id': 'ID',
  'pages.deviceControl.list.region': 'Region',
  'pages.deviceControl.list.iotStatus': 'IoT Status',
  'pages.deviceControl.list.inactive': 'Inactive',
  'pages.deviceControl.list.selectModel': 'Select device model',
  'pages.deviceControl.list.deviceModel': 'Device Model',
  'pages.deviceControl.list.deactivateTitle': 'Confirm Deactivate',
  'pages.deviceControl.list.deactivateSuccess': 'Device deactivated successfully',
  'pages.deviceControl.list.deactivateFailed': 'Failed to deactivate device',
  'pages.deviceControl.list.updateSuccess': 'Device updated successfully',
  'pages.deviceControl.list.updateFailed': 'Failed to update device',
  'pages.deviceControl.list.formValidateFailed': 'Form validation failed',
  'pages.deviceControl.list.migrateSuccess': 'Device number migrated successfully',
  'pages.deviceControl.list.migrateFailed': 'Failed to migrate device number',
  'pages.deviceControl.list.unbindSuccess': 'Device unbound successfully',
  'pages.deviceControl.list.unbindFailed': 'Failed to unbind device',
  'pages.deviceControl.list.fetchModelListFailed': 'Failed to load device model list',
  'pages.deviceControl.list.fetchConfigListFailed': 'Failed to load device config list',
  'pages.deviceControl.list.snCodeRequired': 'Please enter SN code',
  'pages.deviceControl.list.snCodePlaceholder': 'Enter SN code',
  'pages.deviceControl.list.deviceNumberRequired': 'Please enter device number',
  'pages.deviceControl.list.deviceNumberPlaceholder': 'Enter device number',
  'pages.deviceControl.list.selectModelRequired': 'Please select device model',
  'pages.deviceControl.list.deviceConfigRequired': 'Please select device config',
  'pages.deviceControl.list.deviceConfigPlaceholder': 'Select device config',
  'pages.deviceControl.list.enableDisableRequired': 'Please select enable/disable',
  'pages.deviceControl.list.enableDisablePlaceholder': 'Select enable/disable',
  'pages.deviceControl.list.view': 'View',
  'pages.deviceControl.list.viewDevice': 'Device Details',
  'pages.deviceControl.list.viewDeviceInfo': 'Device Details',
  'pages.deviceControl.list.close': 'Close',
  'pages.deviceControl.list.deviceConfigName': 'Device Config Name',
  'pages.deviceControl.list.detail': 'Details',
  /** Device Type */
  'pages.deviceControl.type.typeId': 'Category ID',
  'pages.deviceControl.type.typeName': 'Category Name',
  'pages.deviceControl.type.typeDesc': 'Category Description',
  'pages.deviceControl.type.parentId': 'Parent ID',
  'pages.deviceControl.type.addType': 'Add Category',
  /** Beverage Information */
  'pages.deviceControl.beverage.addTitle': 'Add Beverage',
  'pages.deviceControl.beverage.editTitle': 'Edit Beverage',
  'pages.deviceControl.beverage.beverageId': 'Beverage ID',
  'pages.deviceControl.beverage.beverageIdPlaceholder': 'Enter beverage ID',
  'pages.deviceControl.beverage.beverageIdRequired': 'Please enter beverage ID',
  'pages.deviceControl.beverage.nameCn': 'Chinese Name',
  'pages.deviceControl.beverage.nameCnPlaceholder': 'Enter Chinese name',
  'pages.deviceControl.beverage.nameCnRequired': 'Please enter Chinese name',
  'pages.deviceControl.beverage.nameEn': 'English Name',
  'pages.deviceControl.beverage.nameEnPlaceholder': 'Enter English name',
  'pages.deviceControl.beverage.nameEnRequired': 'Please enter English name',
  'pages.deviceControl.beverage.applicableDevice': 'Applicable Device',
  'pages.deviceControl.beverage.applicableDevicePlaceholder': 'Select applicable device',
  'pages.deviceControl.beverage.applicableDeviceRequired': 'Please select applicable device',
  'pages.deviceControl.beverage.serialDevice': 'Serial Device',
  'pages.deviceControl.beverage.androidDevice': 'Android Device',
  'pages.deviceControl.beverage.statusPlaceholder': 'Select status',
  'pages.deviceControl.beverage.statusRequired': 'Please select status',
  'pages.deviceControl.beverage.deleteConfirm': 'Are you sure to delete "{name}"? This action cannot be undone.',
  'pages.deviceControl.beverage.otherLanguages': 'Other Language Names',
  'pages.deviceControl.beverage.traditionalChinese': 'Traditional Chinese',
  'pages.deviceControl.beverage.traditionalChinesePlaceholder': 'Enter Traditional Chinese name',
  'pages.deviceControl.beverage.korean': 'Korean',
  'pages.deviceControl.beverage.koreanPlaceholder': 'Enter Korean name',
  'pages.deviceControl.beverage.russian': 'Russian',
  'pages.deviceControl.beverage.russianPlaceholder': 'Enter Russian name',
  'pages.deviceControl.beverage.french': 'French',
  'pages.deviceControl.beverage.frenchPlaceholder': 'Enter French name',
  'pages.deviceControl.beverage.spanish': 'Spanish',
  'pages.deviceControl.beverage.spanishPlaceholder': 'Enter Spanish name',
  'pages.deviceControl.beverage.portuguese': 'Portuguese',
  'pages.deviceControl.beverage.portuguesePlaceholder': 'Enter Portuguese name',
  'pages.deviceControl.beverage.indonesian': 'Indonesian',
  'pages.deviceControl.beverage.indonesianPlaceholder': 'Enter Indonesian name',
  'pages.deviceControl.beverage.lithuanian': 'Lithuanian',
  'pages.deviceControl.beverage.lithuanianPlaceholder': 'Enter Lithuanian name',
  'pages.deviceControl.beverage.ukrainian': 'Ukrainian',
  'pages.deviceControl.beverage.ukrainianPlaceholder': 'Enter Ukrainian name',
  'pages.deviceControl.beverage.czech': 'Czech',
  'pages.deviceControl.beverage.czechPlaceholder': 'Enter Czech name',
  'pages.deviceControl.beverage.image': 'Beverage Image',
  'pages.deviceControl.beverage.imageError': 'Only image files are allowed',
  'pages.deviceControl.beverage.imageSizeError': 'Image size cannot exceed 10MB',
  'pages.deviceControl.beverage.initUploadFailed': 'Failed to initialize upload',
  'pages.deviceControl.beverage.getUploadIdFailed': 'Failed to get upload ID',
  'pages.deviceControl.beverage.uploadFailed': 'Failed to upload file',
  'pages.deviceControl.beverage.mergeFailed': 'Failed to merge file',
  'pages.deviceControl.beverage.status': 'Status',
  'pages.deviceControl.beverage.all': 'All',
  /** Beverage Information - Messages */
  'pages.deviceControl.beverage.deleteSuccess': 'Deleted successfully',
  'pages.deviceControl.beverage.deleteFailed': 'Failed to delete',
  'pages.deviceControl.beverage.loadFailed': 'Failed to get beverage information',
  /** Drink List */
  'pages.deviceControl.drink.drinkID': 'Drink ID',
  'pages.deviceControl.drink.drinkName': 'Drink Name',
  'pages.deviceControl.drink.beverageCount': 'Beverage Count',
  'pages.deviceControl.drink.configName': 'Config Name',
  'pages.deviceControl.drink.drinkDetail': 'Drink Detail',
  'pages.deviceControl.drink.beverageInfo': 'Beverage Recipe',
  'pages.deviceControl.drink.alertMessage': 'This feature is only available for serial devices, not for Android devices.',
  'pages.deviceControl.drink.addDrink': 'Add Drink',
  'pages.deviceControl.drink.editDrink': 'Edit Drink',
  'pages.deviceControl.drink.addTitle': 'Add Drink',
  'pages.deviceControl.drink.drinkNamePlaceholder': 'Enter drink name',
  'pages.deviceControl.drink.deleteConfirm': 'Are you sure to delete "{name}"? This action cannot be undone.',
  'pages.deviceControl.drink.deviceConfig': 'Device Config Info',
  'pages.deviceControl.drink.drinkList': 'Drink List',
  'pages.deviceControl.drink.pleaseEnterDrinkName': 'Please enter drink name',
  'pages.deviceControl.drink.configNamePlaceholder': 'Enter config name, separate multiple with commas',
  'pages.deviceControl.drink.pleaseSelectConfig': 'Please select device config info, at least one',
  'pages.deviceControl.drink.pleaseEnterDrinkList': 'Please enter drink list',
  'pages.deviceControl.drink.drinkListPlaceholder': 'Please enter drink list in JSON format',
  /** Drink List - Messages */
  'pages.deviceControl.drink.fetchConfigFailed': 'Failed to get device config information',
  'pages.deviceControl.drink.loadFailed': 'Failed to get drink list',
  'pages.deviceControl.drink.updateSuccess': 'Drink updated successfully',
  'pages.deviceControl.drink.createSuccess': 'Drink created successfully',
  'pages.deviceControl.drink.submitFailed': 'Form submission failed',
  /** Common */
  'pages.common.createTime': 'Create Time',
  'pages.common.updateTime': 'Update Time',
  'pages.common.tips': 'Tips',
  /** Upgrade Package Common */
  'pages.packageManagement.upgrade.editTitle': 'Edit Package',
  'pages.packageManagement.upgrade.addTitle': 'Add Package',
  'pages.packageManagement.upgrade.packageName': 'Package Name',
  'pages.packageManagement.upgrade.version': 'Version',
  'pages.packageManagement.upgrade.description': 'Description',
  'pages.packageManagement.upgrade.type': 'Type',
  'pages.packageManagement.upgrade.forceUpdate': 'Force Update',
  'pages.packageManagement.upgrade.status': 'Status',
  'pages.packageManagement.upgrade.all': 'All',
  'pages.packageManagement.upgrade.uploadFile': 'Upload File',
  'pages.packageManagement.upgrade.submit': 'Submit',
  'pages.packageManagement.upgrade.uploadedFile': 'Uploaded File: ',
  'pages.packageManagement.upgrade.fileLink': 'File Link: ',
  'pages.packageManagement.upgrade.fileSize': 'File Size: ',
  'pages.packageManagement.upgrade.reUpload': 'Re-upload File',
  'pages.packageManagement.upgrade.clickUpload': 'Click to Upload',
  'pages.packageManagement.upgrade.cnDesc': 'Chinese Description',
  'pages.packageManagement.upgrade.enDesc': 'English Description',
  /** App Upgrade Package */
  'pages.packageManagement.appUpgrade.buildNumber': 'Build Number',
  'pages.packageManagement.appUpgrade.validation.buildNumber': 'Please enter build number',
  'pages.packageManagement.appUpgrade.placeholder.buildNumber': 'Please enter build number',
  'pages.packageManagement.appUpgrade.detailTitle': 'Package Details',
  'pages.packageManagement.appUpgrade.detail.descriptionInfo': 'Description Info',
  'pages.packageManagement.appUpgrade.addPackage': 'Add Package',
  'pages.packageManagement.appUpgrade.detail.cn': 'Chinese: ',
  'pages.packageManagement.appUpgrade.detail.tw': 'Traditional: ',
  'pages.packageManagement.appUpgrade.detail.hk': 'HK: ',
  'pages.packageManagement.appUpgrade.detail.en': 'English: ',
  'pages.packageManagement.appUpgrade.detail.fr': 'French: ',
  'pages.packageManagement.appUpgrade.detail.ja': 'Japanese: ',
  'pages.packageManagement.appUpgrade.detail.ko': 'Korean: ',
  'pages.packageManagement.appUpgrade.detail.ru': 'Russian: ',
  'pages.packageManagement.appUpgrade.detail.chinese': 'Chinese',
  'pages.packageManagement.appUpgrade.detail.traditional': 'Traditional Chinese',
  'pages.packageManagement.appUpgrade.detail.hongKong': 'Hong Kong',
  'pages.packageManagement.appUpgrade.detail.english': 'English',
  'pages.packageManagement.appUpgrade.detail.french': 'French',
  'pages.packageManagement.appUpgrade.detail.japanese': 'Japanese',
  'pages.packageManagement.appUpgrade.detail.korean': 'Korean',
  'pages.packageManagement.appUpgrade.detail.russian': 'Russian',
  'pages.packageManagement.appUpgrade.detail.downloadLink': 'Download Link: ',
  'pages.packageManagement.appUpgrade.detail.generalLink': 'General Link',
  'pages.packageManagement.appUpgrade.detail.commonLink': 'Common Link: ',
  'pages.packageManagement.appUpgrade.detail.iosLink': 'iOS Link: ',
  'pages.packageManagement.appUpgrade.detail.androidLink': 'Android Link: ',
  'pages.packageManagement.appUpgrade.detail.qrcode': 'QR Code: ',
  'pages.packageManagement.appUpgrade.detail.qrCode': 'QR Code',
  'pages.packageManagement.appUpgrade.noDownloadLink': 'No download link',
  /** Coffee Upgrade Package */
  'pages.packageManagement.coffeeUpgrade.name': 'Name',
  'pages.packageManagement.coffeeUpgrade.configName': 'Config Name',
  'pages.packageManagement.coffeeUpgrade.fileSize': 'File Size',
  'pages.packageManagement.coffeeUpgrade.type': 'Type',
  'pages.packageManagement.coffeeUpgrade.environment': 'Environment',
  'pages.packageManagement.coffeeUpgrade.environment.product': 'Production',
  'pages.packageManagement.coffeeUpgrade.environment.test': 'Test',
  'pages.packageManagement.coffeeUpgrade.config': 'Config Info',
  'pages.packageManagement.coffeeUpgrade.detail.accessLink': 'Access Link: ',
  /** Upgrade Package Types */
  'pages.packageManagement.upgrade.typeOptions.io': 'IO',
  'pages.packageManagement.upgrade.typeOptions.uiColor': 'UI (Color Screen)',
  'pages.packageManagement.upgrade.typeOptions.audio': 'Audio',
  'pages.packageManagement.upgrade.typeOptions.apk': 'Android APK',
  'pages.packageManagement.upgrade.typeOptions.androidApk': 'Android APK',
  'pages.packageManagement.upgrade.typeOptions.uiSerial': 'UI (Serial Screen)',
  /** Upgrade Dialog - validation & placeholder */
  'pages.packageManagement.upgrade.validation.packageName': 'Please enter package name',
  'pages.packageManagement.upgrade.placeholder.packageName': 'Enter package name',
  'pages.packageManagement.upgrade.validation.version': 'Please enter version number',
  'pages.packageManagement.upgrade.placeholder.version': 'Enter version, e.g. v1.0.0',
  'pages.packageManagement.upgrade.validation.cnDesc': 'Please enter Chinese description',
  'pages.packageManagement.upgrade.placeholder.cnDesc': 'Enter Chinese description',
  'pages.packageManagement.upgrade.validation.enDesc': 'Please enter English description',
  'pages.packageManagement.upgrade.placeholder.enDesc': 'Enter English description',
  'pages.packageManagement.upgrade.validation.forceUpdate': 'Please select force update',
  'pages.packageManagement.upgrade.placeholder.forceUpdate': 'Select force update',
  'pages.packageManagement.upgrade.validation.status': 'Please select status',
  'pages.packageManagement.upgrade.placeholder.status': 'Select status',
  'pages.packageManagement.upgrade.validation.desc': 'Please enter description',
  'pages.packageManagement.upgrade.placeholder.desc': 'Enter description',
  'pages.packageManagement.upgrade.validation.type': 'Please select type',
  'pages.packageManagement.upgrade.placeholder.type': 'Select type',
  'pages.packageManagement.coffeeUpgrade.validation.config': 'Please select config',
  'pages.packageManagement.coffeeUpgrade.placeholder.config': 'Select config',
  'pages.packageManagement.coffeeUpgrade.placeholder.version': 'Enter version, e.g. 78.101',
  /** Upload Package Modal */
  'pages.packageManagement.upload.title': 'Upload Package',
  'pages.packageManagement.upload.fileName': 'File Name: ',
  'pages.packageManagement.upload.fileSize': 'File Size: ',
  'pages.packageManagement.upload.uploadProgress': 'Upload Progress: {progress}%',
  'pages.packageManagement.upload.uploadSuccessText': 'File uploaded successfully!',
  'pages.packageManagement.upload.uploadFailedText': 'File upload failed, please retry!',
  'pages.packageManagement.upload.uploading': 'Uploading...',
  'pages.packageManagement.upload.reUpload': 'Re-upload',
  'pages.packageManagement.upload.confirmUpload': 'Confirm Upload',
  'pages.packageManagement.upload.selectFile': 'Please select a file to upload',
  'pages.packageManagement.upload.uploadFailRetry': 'Upload failed, please retry',
  'pages.packageManagement.upload.getUploadIdFailed': 'Failed to get upload ID, please check network',
  'pages.packageManagement.upload.initUploadFailed': 'Upload initialization failed',
  'pages.packageManagement.upload.initChunkUploadFailed': 'Chunk upload initialization failed',
  'pages.packageManagement.upload.chunkUploadFailed': 'Chunk {index} upload failed',
  'pages.packageManagement.upload.chunkReuploadFailed': 'Chunk {index} re-upload failed',
  'pages.packageManagement.upload.remergeFailed': 'File re-merge failed',
  'pages.packageManagement.upload.getMissingChunksFailed': 'Failed to get missing chunks',
  'pages.packageManagement.upload.mergeFailed': 'File merge failed',
  /** Agreement Popup */
  'pages.applicationManagement.agreementPop.agreementName': 'Agreement Name',
  'pages.applicationManagement.agreementPop.agreementName.placeholder': 'Enter agreement name',
  'pages.applicationManagement.agreementPop.language': 'Language',
  'pages.applicationManagement.agreementPop.language.placeholder': 'Select language',
  'pages.applicationManagement.agreementPop.agreementType': 'Agreement Type',
  'pages.applicationManagement.agreementPop.agreementType.placeholder': 'Select agreement type',
  'pages.applicationManagement.agreementPop.uploadAgreement': 'Upload Agreement',
  'pages.applicationManagement.agreementPop.reUpload': 'Re-upload Agreement',
  'pages.applicationManagement.agreementPop.clickUpload': 'Click to Upload',
  'pages.applicationManagement.agreementPop.uploadedFile': 'Uploaded File: ',
  'pages.applicationManagement.agreementPop.fileLink': 'File Link: ',
  'pages.applicationManagement.agreementPop.uploadSuccess': 'Agreement uploaded successfully',
  /** Order List */
  'pages.orderControl.order.number': 'Order No.',
  'pages.orderControl.order.deviceId': 'Device No.',
  'pages.orderControl.order.productId': 'Product ID',
  'pages.orderControl.order.createTime': 'Create Time',
  'pages.orderControl.order.startTime': 'Start Time',
  'pages.orderControl.order.endTime': 'End Time',
  'pages.orderControl.order.status': 'Status',
  'pages.orderControl.order.detail': 'Detail',
  'pages.orderControl.order.detailTitle': 'Order Details',
  'pages.orderControl.order.macId': 'MAC ID',
  'pages.orderControl.order.productName': 'Product Name',
  'pages.orderControl.order.recipeName': 'Recipe Name',
  'pages.orderControl.order.canisterId': 'Canister ID',
  'pages.orderControl.order.quantity': 'Quantity',
  'pages.orderControl.order.amount': 'Amount',
  'pages.orderControl.order.discount': 'Discount',
  'pages.orderControl.order.paidAmount': 'Paid Amount',
  'pages.orderControl.order.paymentMethod': 'Payment Method',
  'pages.orderControl.order.makeTime': 'Make Time',
  'pages.orderControl.order.updateTime': 'Update Time',
  'pages.orderControl.order.failReason': 'Failure Reason',
  'pages.orderControl.order.queryRule': 'Query Rules',
  'pages.orderControl.order.queryDesc': 'Status and time are required; start time must not be later than end time, and cannot span across months.',
  'pages.orderControl.order.selectStatus': 'Please select order status',
  'pages.orderControl.order.selectTime': 'Please select both start and end time',
  'pages.orderControl.order.startAfterEnd': 'Start time cannot be later than end time',
  'pages.orderControl.order.crossMonth': 'Time range cannot span across months',
  'pages.orderControl.order.selectStart': 'Please select start time',
  'pages.orderControl.order.selectEnd': 'Please select end time',
  /** Menu Add/Update Dialog */
  'pages.accessControl.menu.order': 'Menu Order',
  'pages.accessControl.menu.ruleOrder': 'Please enter menu order',
  'pages.accessControl.menu.placeholderOrder': 'Enter menu order',
  'pages.accessControl.menu.name': 'Menu Name',
  'pages.accessControl.menu.ruleName': 'Please enter menu name',
  'pages.accessControl.menu.placeholderName': 'Enter menu name',
  'pages.accessControl.menu.path': 'API Path',
  'pages.accessControl.menu.placeholderPath': 'Enter API path',
  'pages.accessControl.menu.componentsPath': 'Menu Path',
  'pages.accessControl.menu.placeholderComponentsPath': 'Enter menu path',
  'pages.accessControl.menu.icon': 'Menu Icon',
  'pages.accessControl.menu.placeholderIcon': 'Select menu icon',
  'pages.accessControl.menu.type': 'Menu Type',
  'pages.accessControl.menu.placeholderType': 'Select menu type',
  'pages.accessControl.menu.isLogin': 'Login Required',
  'pages.accessControl.menu.isShow': 'Visible',
  'pages.accessControl.menu.type.directory': 'Directory',
  'pages.accessControl.menu.type.menu': 'Menu',
  'pages.accessControl.menu.type.button': 'Button',
  'pages.accessControl.menu.type.api': 'API',
  'pages.accessControl.menu.icon.home': 'Home',
  'pages.accessControl.menu.icon.user': 'User',
  'pages.accessControl.menu.icon.table': 'Table',
  'pages.accessControl.menu.icon.menu': 'Menu',
  'pages.accessControl.menu.icon.key': 'Key',
  'pages.accessControl.menu.icon.crown': 'Crown',
  'pages.accessControl.menu.icon.smile': 'Smile',
  'pages.accessControl.menu.icon.setting': 'Settings',
  /** Menu Management - Messages */
  'pages.accessControl.menuManagement.loadFailed': 'Failed to load menu list',
  'pages.accessControl.menuManagement.createSuccess': 'Menu created successfully',
  'pages.accessControl.menuManagement.createFailed': 'Failed to create menu',
  'pages.accessControl.menuManagement.updateSuccess': 'Menu updated successfully',
  'pages.accessControl.menuManagement.updateFailed': 'Failed to update menu',
  'pages.accessControl.menuManagement.deleteSuccess': 'Menu deleted successfully',
  'pages.accessControl.menuManagement.deleteFailed': 'Failed to delete menu',
  'pages.accessControl.menuManagement.deleteConfirm': 'Are you sure to delete this menu item? This action cannot be undone.',
  'pages.accessControl.menuManagement.formValidateFailed': 'Form validation failed',
  'pages.accessControl.menuManagement.hidden': 'Hidden',
  'pages.accessControl.menuManagement.loading': 'Loading...',
  /** Login Page - Form Labels */
  'pages.login.username.label': 'Username',
  'pages.login.password.label': 'Password',
  'pages.login.captcha.label': 'Captcha',
  'pages.login.captcha.invalid': 'Please enter a valid captcha!',
  'pages.login.captcha.alt': 'Captcha',
  'pages.login.captcha.refresh': 'Click to refresh',
  'pages.login.forgotPassword.notAvailable': 'Forgot password feature under development',
  'pages.login.submitText': 'Login',
  /** Dashboard */
  'pages.dashboard.title': 'Dashboard',
  'pages.dashboard.deviceOnlineCount': 'Online/Total Devices',
  'pages.dashboard.mobileUserCount': 'Online/Total Mobile Users',
  'pages.dashboard.dailyCups': 'Daily Cups Made',
  'pages.dashboard.modelCupRanking': 'Model Cup Ranking',
  'pages.dashboard.totalCups': 'Total Cups Made',
  'pages.dashboard.unitYuan': 'CNY',
  'pages.dashboard.userVisits': 'User Visits',
  'pages.dashboard.drinkDistribution': 'Drink Distribution',
  'pages.dashboard.drinkCupRanking': 'Drink Cup Ranking',
  'pages.dashboard.total': 'Total',
  'pages.dashboard.table.rank': 'Rank',
  'pages.dashboard.table.name': 'Name',
  'pages.dashboard.table.type': 'Type',
  'pages.dashboard.table.region': 'Region',
  'pages.dashboard.table.industry': 'Industry',
  'pages.dashboard.table.market': 'Market',
  'pages.dashboard.table.percentage': 'Percentage',
  'pages.dashboard.online': 'Online',
  'pages.dashboard.offline': 'Offline',
  'pages.dashboard.completed': 'Completed',
  'pages.dashboard.notCompleted': 'Incomplete',
  'pages.dashboard.loading': 'Loading...',
  'pages.dashboard.salesCups': 'Cups Sold',
  'pages.dashboard.cupsUnit': '{cups} cups',
  /** Recipe Material Consumption */
  'pages.dashboard.recipeMaterialConsumption': 'Recipe Material Consumption',
  'pages.dashboard.totalMaterialConsumption': 'Total Material Consumption',
  'pages.dashboard.averageConsumption': 'Average Consumption',
  'pages.dashboard.dataLoading': 'Loading data...',
  /** Upgrade Package List - Vulnerability Submit */
  'pages.upgradePackageList.uploadFileCountLimit': 'Total upload files cannot exceed 10',
  'pages.upgradePackageList.uploadFileSizeLimit': 'Single file size cannot exceed 150MB',
  'pages.upgradePackageList.mergeFileFailed': 'File merge failed',
  'pages.upgradePackageList.uploadFailed': 'Upload failed',
  'pages.upgradePackageList.enterEmailFirst': 'Please enter email address first',
  'pages.upgradePackageList.invalidEmail': 'Please enter a valid email address',
  'pages.upgradePackageList.verificationCodeSent': 'Verification code sent',
  'pages.upgradePackageList.severityLow': 'Low',
  'pages.upgradePackageList.severityMedium': 'Medium',
  'pages.upgradePackageList.severityHigh': 'High',
  'pages.upgradePackageList.chunkReuploadFailed': 'Chunk {index} re-upload failed',
  'pages.upgradePackageList.getMissingChunksFailed': 'Failed to get missing chunks',
};
